import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { AllAssetsType } from 'services/requests';
import { QueryKeys } from 'constants/queryKeys';

export const useGetAllAssets = () => {
  const queryFn = async (): Promise<AllAssetsType> => {
    const { data } = await api.getAllAssets();

    const allAssets: AllAssetsType = {};
    data.items.forEach((item) => {
      allAssets[item.id] = item;
    });

    return allAssets;
  };

  const queryKey = QueryKeys.allAssets;

  return useQuery<AllAssetsType, AxiosError<ApiError>>(queryKey, queryFn, {
    staleTime: 3600000,
  });
};
